import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-file" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Info", -1)
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = { class: "col-md-12 p-4" }
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Name:")
], -1)
const _hoisted_12 = { class: "col-md-8" }
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Email Address:")
], -1)
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Phone Number:")
], -1)
const _hoisted_19 = { class: "col-md-8" }
const _hoisted_20 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_21 = {
  key: 1,
  class: "row mb-3"
}
const _hoisted_22 = {
  key: 0,
  class: "error-no-record mt-3"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-fw pi-lock" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Password", -1)
const _hoisted_26 = {
  key: 1,
  class: "row"
}
const _hoisted_27 = { class: "col-md-12 p-4 d-flex" }
const _hoisted_28 = { class: "col-md-8 pe-2" }
const _hoisted_29 = { class: "row mb-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Current Password:")
], -1)
const _hoisted_31 = { class: "col-md-7" }
const _hoisted_32 = { class: "row mb-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "New Password:")
], -1)
const _hoisted_34 = { class: "col-md-7" }
const _hoisted_35 = { class: "row mb-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Confirm Password:")
], -1)
const _hoisted_37 = { class: "col-md-7" }
const _hoisted_38 = {
  key: 0,
  class: "col-md-5"
}
const _hoisted_39 = {
  key: 1,
  class: "col-md-7 p-error"
}
const _hoisted_40 = { class: "col-md-4 ps-2" }
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-md-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-password-policy-title" }, "Password Policy:", -1)
const _hoisted_45 = { class: "pl-2 ml-2 mt-0 col-form-password-policy" }
const _hoisted_46 = { class: "row mb-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1)
const _hoisted_48 = { class: "d-flex col-md-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader),
              _createVNode(_component_TabView, { class: "p-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_TabPanel, null, {
                    header: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      (_ctx.isPageLoading)
                        ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_ctx.isPageLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_component_InputText, {
                                    class: "p-inputtext",
                                    type: "text",
                                    maxlength: "50",
                                    placeholder: "Name",
                                    modelValue: _ctx.employee.name,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employee.name) = $event)),
                                    readonly: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_Button, {
                                    class: "col-md-12 text-start p-button-link ps-2 pe-0",
                                    label: _ctx.employee.emailAddress
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        class: "p-button-link",
                                        href: 'mailto:' + _ctx.employee.emailAddress
                                      }, _toDisplayString(_ctx.employee.emailAddress), 9, _hoisted_16)
                                    ]),
                                    _: 1
                                  }, 8, ["label"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _hoisted_18,
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_InputText, {
                                    class: "p-inputtext",
                                    type: "text",
                                    maxlength: "15",
                                    modelValue: _ctx.employee.mobilePhone,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employee.mobilePhone) = $event)),
                                    readonly: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              (_ctx.employee.employeeCompanies != null && _ctx.employee.employeeCompanies.length != 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_Divider)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.employee.employeeCompanies != null && _ctx.employee.employeeCompanies.length != 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_DataTable, {
                                      value: _ctx.employee.employeeCompanies,
                                      responsiveLayout: "scroll",
                                      selectionMode: "single"
                                    }, {
                                      empty: _withCtx(() => [
                                        (_ctx.employee.employeeCompanies.length <= 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              _createVNode(_component_FontAwesomeIcon, {
                                                icon: ['fas', 'image'],
                                                size: "2x"
                                              }),
                                              _hoisted_23
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          style: {"width":"100%"},
                                          field: "company.name",
                                          header: "Company"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_TabPanel, null, {
                    header: _withCtx(() => [
                      _hoisted_24,
                      _hoisted_25
                    ]),
                    default: _withCtx(() => [
                      (_ctx.isPageLoading)
                        ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_ctx.isPageLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _hoisted_30,
                                  _createElementVNode("div", _hoisted_31, [
                                    _createVNode(_component_Password, {
                                      maxlength: "50",
                                      placeholder: "Current Password",
                                      modelValue: _ctx.password.currentPassword,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password.currentPassword) = $event)),
                                      feedback: false,
                                      toggleMask: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_Password, {
                                      strongRegex: _ctx.strongRegex,
                                      class: _normalizeClass({'p-invalid': (_ctx.passwordNotMatch || _ctx.v$.password.newPassword.strongRegexValidator.$invalid) && _ctx.password.newPassword != ''}),
                                      toggleMask: "",
                                      maxlength: "50",
                                      placeholder: "New Password",
                                      modelValue: _ctx.password.newPassword,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password.newPassword) = $event))
                                    }, null, 8, ["strongRegex", "class", "modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _hoisted_36,
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_Password, {
                                      strongRegex: _ctx.strongRegex,
                                      class: _normalizeClass({'p-invalid': (_ctx.passwordNotMatch || _ctx.v$.password.confirmPassword.strongRegexValidator.$invalid) && _ctx.password.confirmPassword != ''}),
                                      toggleMask: "",
                                      maxlength: "50",
                                      placeholder: "Confirm Password",
                                      modelValue: _ctx.password.confirmPassword,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.password.confirmPassword) = $event))
                                    }, null, 8, ["strongRegex", "class", "modelValue"])
                                  ]),
                                  (_ctx.passwordNotMatch)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                                    : _createCommentVNode("", true),
                                  (_ctx.passwordNotMatch)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_39, "Passwords do not matched."))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _hoisted_44,
                                      _createElementVNode("ul", _hoisted_45, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordPolicy, (policies) => {
                                          return (_openBlock(), _createElementBlock("li", { key: policies }, _toDisplayString(policies), 1))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              _createElementVNode("div", _hoisted_48, [
                                _createVNode(_component_Button, {
                                  class: "p-button-sm",
                                  disabled: _ctx.v$.password.$invalid || _ctx.isLoading,
                                  onClick: _ctx.updatePassword,
                                  label: "Save"
                                }, null, 8, ["disabled", "onClick"]),
                                (_ctx.isLoading)
                                  ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}